<template>
  <div class="verifyCode">
    <h1>请输入验证码</h1>
    <div class="tip">
      已发送至手机 {{ phone }}
      <span @click="againSendCode" :style="time !== 60 ? 'color:#FE8900' : ''">
        {{ time === 60 ? "重新获取验证码" : "重新发送(" + time + "s)" }}</span
      >
    </div>
    <div class="boxs">
      <div class="box" @click="showKeyboard = true">
        {{ verifyCode.length >= 1 ? verifyCode[0] : "" }}
      </div>
      <div class="box" @click="showKeyboard = true">
        {{ verifyCode.length >= 2 ? verifyCode[1] : "" }}
      </div>
      <div class="box" @click="showKeyboard = true">
        {{ verifyCode.length >= 3 ? verifyCode[2] : "" }}
      </div>
      <div class="box" @click="showKeyboard = true">
        {{ verifyCode.length >= 4 ? verifyCode[3] : "" }}
      </div>
    </div>
    <NumberKeyboard
      :show="showKeyboard"
      @blur="showKeyboard = false"
      @input="onInput"
      @delete="onDelete"
    />
  </div>
</template>

<script>
import { NumberKeyboard } from "vant";
let IntervalCountdownId;
export default {
  name: "VerifyCodeInputPage",
  props: {
    phone: {
      type: String
    }
  },
  data: function() {
    return {
      verifyCode: [],
      showKeyboard: true,
      time: 60
    };
  },
  created() {
    if (IntervalCountdownId) {
      clearInterval(IntervalCountdownId);
    }
    this.time = 59;
    IntervalCountdownId = setInterval(() => {
      if (this.time <= 0) {
        clearInterval(IntervalCountdownId);
        this.time = 60;
        return;
      }
      this.time--;
    }, 1000);
  },
  methods: {
    onInput(value) {
      if (this.verifyCode.length >= 4) {
        return;
      }
      this.verifyCode.push(value);
      if (this.verifyCode.length === 4) {
        this.showKeyboard = false;
        setTimeout(() => {
          this.$emit("doneInput", this.verifyCode.join(""));
        }, 100);
      }
    },
    onDelete() {
      let len = this.verifyCode.length;
      this.verifyCode.splice(len - 1, 1);
    },
    TriggerAgainSendCode(verifyParams) {
      this.againSendCode(verifyParams);
    },
    againSendCode(verifyParams = {}) {
      if (this.time !== 60) {
        return;
      }
      this.verifyCode = [];
      this.$emit(
        "againSendCode",
        this.phone,
        () => {
          this.showKeyboard = true;
          IntervalCountdownId = setInterval(() => {
            if (this.time <= 0) {
              clearInterval(IntervalCountdownId);
              this.time = 60;
              return;
            }
            this.time--;
          }, 1000);
        },
        verifyParams
      );
    }
  },
  components: { NumberKeyboard }
};
</script>
<style lang="scss" scoped>
.verifyCode {
  h1 {
    color: #222;
    font-size: 24px;
    font-weight: 500;
    margin-top: 56px;
    margin-bottom: 22px;
    text-align: center;
  }
  .tip {
    text-align: center;
    color: #969fa9;
    font-size: 15px;
    span {
      color: #04498d;
    }
  }
  .boxs {
    margin: 50px auto 0;
    width: 222px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    .box {
      width: 44px;
      height: 44px;
      background-color: #f9f9f9;
      border: 1px solid #eeeeee;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      color: #333333;
    }
  }
}
</style>
